import script from "./DetailPaperprods.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailPaperprods.vue?vue&type=script&setup=true&lang=js"

import "./DetailPaperprods.vue?vue&type=style&index=0&id=18242a78&lang=scss"

const __exports__ = script;

export default __exports__